export function injectCheckmark(container: HTMLElement): void {
  const checkmark = document.createElement('span');
  checkmark.classList.add('checkmark');

  const icon = document.createElement('i');
  icon.classList.add('xlent-icon-checkmark');
  checkmark.appendChild(icon);

  container.appendChild(checkmark);
}

export default function initFormCheckboxes(): void {
  const singleCheckboxes = document.querySelectorAll<HTMLElement>(
    '.checkbox .umbraco-forms-field-wrapper, .dataconsent .umbraco-forms-field-wrapper'
  );

  singleCheckboxes.forEach(injectCheckmark);

  document.querySelectorAll<HTMLElement>(
    '.multiplechoice .checkboxlist > div'
  ).forEach(injectCheckmark);
}
